module.exports = __webpack_public_path__ + "static/media/ringing.324e579c.wav";